<template>
  <v-dialog :value="isActive" max-width="1000" persistent>
    <v-card class="text-center pop-up" height="100%">
      <v-card-title class="text-sm-left font-weight-bold px-5">
        Đo lường tương tác
        <v-divider style="border-color: #d2d2d2" class="mt-3 mb-3"></v-divider>
        <v-spacer />
        <v-icon aria-label="Close" @click="closeModal">mdi-close</v-icon>
      </v-card-title>
      <v-card-text class="px-9 pt-0">
        <v-row>
          <b style="margin-right: 10px">Thời gian tương tác: </b>
          <v-btn
            :color="isAll ? '#fc8803' : '#f5d8ae'"
            class="mr-2 black--text font-weight-bold"
            small
            @click="getFilterDetailContact('all')"
          >Tất cả</v-btn>
          <v-btn
            :color="isLastMonth ? '#fc8803' : '#f5d8ae'"
            class="mr-2 black--text font-weight-bold"
            small
            @click="getFilterDetailContact('lastMonth')"
          >Tháng trước</v-btn>
          <v-btn
            :color="isThisMonth ? '#fc8803' : '#f5d8ae'"
            class="mr-2 black--text font-weight-bold"
            small
            @click="getFilterDetailContact('thisMonth')"

          >Tháng này</v-btn>

          <!-- <v-tooltip
            v-model="show"
          >
            <template>
              <v-btn
                color="grey"
                class="mr-2"
                small
                @click="show = !show"
              >
                Tùy chọn
                <v-icon right dark>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-btn
              color="grey"
              class="mr-2"
              small
              @click="getFilterDetailContact('option')"
            >
              Programmatic tooltip
            </v-btn>
          </v-tooltip> -->

          <v-menu attach offset-y :close-on-content-click="false" class="select-option">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="isOption ? '#fc8803' : '#f5d8ae'"
                @click="isOption = !isOption"
                dark
                small
                v-bind="attrs"
                v-on="on"
                class="black--text font-weight-bold"
              >
                Tùy chọn
                <template v-if="month">
                  (Tháng {{month}})
                </template>
                <v-icon right dark>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <div style="padding: 15px 25px 8px">
              <v-row>
                <v-select
                  style="width:108px; margin-right:10px"
                  :items="months"
                  v-model="month"
                  placeholder="Tháng"
                  @change="getFilterDetailContact('option')"
                  outlined
                  dense
                  class="select-date"
                ></v-select>

                <v-select
                  :items="years"
                  v-model="year"
                  placeholder="Năm"
                  style="width:83px"
                  @change="getFilterDetailContact('option')"
                  outlined
                  dense
                  class="select-date"
                ></v-select>
              </v-row>
              <div v-if="showErrors" style="color: red; transform: translateX(-15px);font-size: 12px;">Vui lòng chọn đầy đủ tháng, năm</div>
            </div>
          </v-menu>
        </v-row>
        <br>
        <v-row>
          <v-col justify="space-around">
            <v-badge avatar bordered overlap color="white">
              <template v-slot:badge>
                <v-avatar size="100">
                  <v-img src="../../../../public/img/bookmarks-24px.svg"></v-img>
                </v-avatar>
              </template>
              <v-avatar size="60">
                <div id="rounded-card">
                  <b
                    class="centered"
                    style="margin: auto; color: rgb(123, 0, 88)"
                    >{{ dataInteraction.cycle_point }}</b
                  >
                </div>
              </v-avatar>
            </v-badge>
            <p style="margin: auto; color: rgb(123, 0, 88)">
              <b>Điểm chu kỳ</b>
            </p>
          </v-col>
          <v-col justify="space-around">
            <v-badge avatar bordered overlap color="white">
              <template v-slot:badge>
                <v-avatar>
                  <v-img light src="../../../../public/img/mu.png"></v-img>
                </v-avatar>
              </template>
              <v-avatar size="60">
                <div id="rounded-card">
                  <b
                    class="centered"
                    style="margin: auto; color: rgb(255, 24, 133)"
                    >{{ dataInteraction.cumulative_point }}</b
                  >
                </div>
              </v-avatar>
            </v-badge>
            <p style="margin: auto; color: rgb(255, 24, 133)">
              <b>Điểm luỹ kế</b>
            </p>
          </v-col>
        </v-row>
        <v-divider style="border-color: #d2d2d2" class="mt-3 mb-3"></v-divider>
<!--        <v-data-table-->
<!--          :dense="true"-->
<!--          :footer-props="{-->
<!--            'items-per-page-options': rowsPerPageOptions,-->
<!--          }"-->
<!--          :headers="headers"-->
<!--          :items="dataInteraction.listActions"-->
<!--          :options.sync="pagination"-->
<!--          class="elevation-1"-->
<!--        >-->
<!--          <template v-slot:footer></template>-->
<!--        </v-data-table>-->

        <v-data-table
            :headers="headers"
            :items="dataInteraction.listActions"
            :hide-default-footer="true"
        >
          <template
              v-slot:item="{ item }">
            <tr>
              <td class="text-left">
                {{item.fullName}}
              </td>
              <td class="text-left">
                {{item.create_date}}
              </td>
              <td class="text-center">
                <v-tooltip bottom v-if="!_.isEmpty(item.data)">
                  <template v-slot:activator="{ on }">
                    <v-btn class="btn-show-modal-count-interaction"
                           :href="_.get(item.data, 'url', '')"
                           target="_blank"
                           icon
                           small
                           color="info"
                           v-on="on"
                    >
                      <v-icon color="pink">mdi-file-document</v-icon>
                    </v-btn>

                    <span class="custom-span-title-study-result pl-1">{{ _.get(item, 'interaction', '') }}</span>
                  </template>
                  <span>Xem nhận xét</span>
                </v-tooltip>
                <span v-else>{{_.get(item, 'interaction', '')}}</span>
              </td>
              <td>
                {{item.point}}
              </td>
            </tr>
          </template>
        </v-data-table>
        <v-col class="pb-0"
               style="display: flex; justify-content: flex-end; padding: 0 12px">
          <div class="d-flex">
            <div class="text-right mb-1 mt-2">
              <template v-if="this.totalItemActionLogs">
                {{showContactsIndex()}}
              </template>
              <v-btn
                  small
                  class="pagination-btn-left"
                  :disabled="currentPage == 1"
                  @click="previousPage"
              >
                <v-icon>mdi-menu-left</v-icon>
              </v-btn>
              <v-btn
                  small
                  class="pagination-btn-right"
                  :disabled="currentPage >= getTotalItem(totalItemActionLogs, limit)"
                  @click="nextpage"
              >
                <v-icon>mdi-menu-right</v-icon>
              </v-btn>
            </div>
            <div style="width: 35px" v-if="totalItemActionLogs">
              <v-text-field
                  v-model="pendingPage"
                  :max="getTotalItem(totalItemActionLogs, limit)"
                  class="pt-0"
                  min="1"
                  step="1"
                  type="number"
                  @input="applyPendingPage(getTotalItem(totalItemActionLogs, limit))"
              >
              </v-text-field>
            </div>
          </div>
        </v-col>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
export default {
  name: "ContactStatusFilterForm",
  props: {
    dataInteraction: {
      default: () => ({}),
    },
    contact: {
      default: () => ({}),
    },
    isActiveCountInteractions: Boolean,
    totalItemActionLogs: Number,
    currentPage: Number
  },
  data() {
    return {
      page: 1,
      pagination: {},
      rowsPerPageOptions: [50, 100, 150],
      isActive: this.isActiveCountInteractions,
      headers: [
        {
          text: "Tên con",
          align: "start",
          value: "fullName",
          class: "header-title",
          sortable: false,
        },
        {
          text: "Ngày",
          align: "start",
          sortable: false,
          value: "create_date",
          class: "header-title",
        },
        {
          text: "Tương tác",
          align: "center",

          value: "interaction",
          sortable: false,
          class: "header-title",
        },

        {
          text: "Điểm tương tác",
          align: "center",
          value: "point",
          sortable: false,
          class: "header-title",
        },
      ],
      month: null,
      year: null,
      months: [],
      years: [],
      isAll: false,
      isLastMonth: false,
      isThisMonth: true,
      isOption: false,
      showErrors: false,
      //currentPage: 1,
      limit: 10,
      totalItem: null,
      pendingPage: 1,
    };
  },
  methods: {
    closeModal() {
      this.isActive = false;
      this.month = null;
      this.year = null;
      this.$emit("closePopUp", false);
    },
    getFilterDetailContact(status) {
      this.pendingPage = 1;

      if ((this.month || this.year) && (!this.month || !this.year)){
        this.showErrors = true;
      }else {
        this.showErrors = false;
      }
      let date = new Date()
      if (status == 'all') {
        this.month = null
        this.year = null
        this.isAll = true
        this.isLastMonth = false
        this.isThisMonth = false
        this.isOption = false
        Bus.$emit('get-detail-contact-quickview', {});
      }
      if (status == 'lastMonth') {
        this.month = moment().subtract(1, 'month').format('MM');
        this.year = moment().subtract(1, 'month').format('YYYY');
        this.isAll = false
        this.isLastMonth = true
        this.isThisMonth = false
        this.isOption = false
        Bus.$emit('get-detail-contact-quickview', {});
      }
      if (status == 'thisMonth') {
        this.month = date.getMonth() + 1
        this.year = date.getFullYear()
        this.isAll = false
        this.isLastMonth = false
        this.isThisMonth = true
        this.isOption = false
      }
      if (status == 'option') {
        this.isAll = false
        this.isLastMonth = false
        this.isThisMonth = false
        this.isOption = true
      }
      const dateTime = {
        month: this.month,
        year: this.year
      }
      //this.$emit('update:currentPage', this.currentPage)
      Bus.$emit('get-detail-contact-quickview', dateTime);
      Bus.$emit('count-list-filter', dateTime);
    },
    showContactsIndex(){
      let maxIndex = parseInt(this.currentPage)*parseInt(this.limit)
      if (maxIndex >= this.totalItemActionLogs) {
        return (maxIndex - parseInt(this.limit) + 1) + ' - ' + this.totalItemActionLogs
      } else {
        return (maxIndex - parseInt(this.limit) + 1) + ' - ' + maxIndex
      }
    },
    applyPendingPage: _.debounce(function(maxPage) {
      if (this.pendingPage < 1) {
        this.pendingPage = this.currentPage
        this.$emit('update:currentPage',this.currentPage)
        return
      }
      if (this.pendingPage > maxPage) {
        this.pendingPage = maxPage
        this.currentPage = parseInt(this.pendingPage)
        this.$emit('update:currentPage',this.currentPage)
        return
      }
      this.currentPage = parseInt(this.pendingPage)
      this.$emit('update:currentPage',this.currentPage)
      return
    }, 1000),
    nextpage(){
      this.currentPage++
      this.$emit('update:currentPage',this.currentPage)
      this.pendingPage++
    },
    previousPage(){
      this.currentPage--
      this.$emit('update:currentPage',this.currentPage)
      this.pendingPage--
    },
  },
  created() {
    this.months = []
    this.years = []
    this.month = null
    this.year = null

    for (let x=1; x<=12; x++) {
      this.months.push({
        text: `Tháng ${x}`,
        value: x
      })
    }

    for (let y=2020; y<=2030; y++) {
      this.years.push({
        text: `${y}`,
        value: y
      })
    }
  },
  watch: {
    currentPage: {
      handler() {
        Bus.$emit('count-list-filter');
      }
    },
  }
};
</script>

<style scoped lang="css" >

/deep/ .v-subheader.theme--light {
  font-size: 10px;
  font-weight: bold;
}

.contact-history-table--wrapper {
  max-height: 280px;
  overflow: auto;
}

.centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.data-table-dense-header-height {
  font-size: 10px;
  font-weight: bold;
}
#rounded-card {
  position: relative;
  text-align: center;
  border-radius: 50%;
  min-height: 128px;
  min-width: 128px;
  background: yellow;
}

/deep/ .v-tabs-bar {
  height: 30px;
}

/deep/ .v-tab {
  font-size: 12px;
}

/deep/ .v-data-footer__select{
  height: 30px;
}
/deep/ .text-start.header-title{
    font-size: 16px;
  font-weight: bold;
}
/deep/ .text-center.header-title{
    font-size: 16px;
  font-weight: bold;
}
.appointment-time-wrapper {
  padding: 5px;
  border: 1px solid #a9a9a9;
  border-radius: 5px;
  font-weight: 700;
}
.select-option .menuable__content__active{
  background: #FFFFFF!important;
}
</style>
<style lang="scss">
.select-date .v-input__control .v-text-field__details{
  display: none!important;
}
.pagination-btn-left, .pagination-btn-right {
  max-width: 30px !important;
  min-width: 30px !important;
  background-color: #ffffff !important;
}
.pagination-btn-left i, .pagination-btn-right i {
  color: rgba(0,0,0,.54) !important
}
.pagination-btn-left {
  margin: 0px 5px 2px 10px !important;
}
.pagination-btn-right {
  margin: 0px 10px 2px 5px !important;
}
</style>
